if (window.location.href.includes('/cart')) {
    document.addEventListener("DOMContentLoaded", async () => {

       let cart = document.querySelector('.cart__summary');
            if (cart) {
              let alreadyHandled = false;
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.addedNodes.length && !alreadyHandled) {
                          console.log("123:", m)
                         alreadyHandled = true;
                           BSS_B2B.observer.cartSubject.listenCartCheckout() 
                          // setTimeout(()=>{
                            
                          // }, 500)
                           // BSS_B2B.nt.initFunction();
                          document.dispatchEvent(new Event("DOMContentLoaded"))
                        }
                    });
                });
                observer.observe(cart, {childList: true});
            }
    })
 
} else {
    document.addEventListener("DOMContentLoaded", async () => {
        let cart = document.querySelector('#cart-drawer-form');
            if (cart) {
              let alreadyHandled = false;
                let observer = new MutationObserver(function(mutations) {
                    mutations.forEach(function(m) {
                        if (m.target.id.includes('cart-items') && m.type === 'attributes' && m.attributeName === 'data-empty' && !alreadyHandled) {
                         console.log(123, m);
                          alreadyHandled = true;
                           BSS_B2B.observer.cartSubject.listenCartCheckout() 
                          // setTimeout(()=>{
                            
                          // }, 500)
                           // BSS_B2B.nt.initFunction();
                          document.dispatchEvent(new Event("DOMContentLoaded"))
                        }
                    });
                });
                observer.observe(cart, {subtree: true, attributes: true});
            }
    })
}

if (window.BSS_BCP) {
  // BSS_BCP.addAction("custom_apply_collection_page_quote", function ({ applyCollectionPage, quoteConfig, translations, shopData }) {
  //   const quickAddObserver = new MutationObserver(function (mutations, observer) {
  //     for (const mutation of mutations) {
  //       setTimeout(function () {
  //         if (mutation.type === "attributes" && mutation.attributeName === "open") {
  //           applyCollectionPage(shopData, BSS_BCP, quoteConfig, BSS_BCP.quoteBtnConfig, translations);
  //         }
  //       }, 600);
  //     }
  //   });
  //   quickAddObserver.observe(document.querySelector("quick-add-drawer"), { attributes: true });
  // });
}